var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{style:(`background-color: ${(_vm.$vuetify.theme.dark) ? '' : '#eef0f3'}`)},[_c('layout'),(_vm.token && _vm.userDetails.isTenantAuthorized)?_c('nav-bar'):_vm._e(),_c('app-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }